define('modules/form_editor/views/field_editor',['require','exports','module','base/layout','./base_element_editor','./editor_advanced_common','./editor_advanced_custom','./field_editor_title','lib/util','./editor_text','./editor_textarea','./editor_checkgroup','./editor_radiogroup','./editor_dropdown','./editor_hidden','./editor_custom_terms','./editor_custom_privacy','./editor_custom_telephone','./editor_custom_email','./editor_custom_date','./editor_custom_date','./editor_custom_gender','./editor_custom_password','./editor_custom_iban','./editor_custom_range','./editor_custom_month','./editor_custom_range','./editor_custom_fblogin','./editor_custom_linlogin','./editor_custom_google_recaptcha','./editor_custom_separator','ldsh!../templates/editor_advanced_dropdown','ldsh!../templates/editor_advanced_variable','ldsh!../templates/editor_advanced_variable','ldsh!../templates/editor_advanced_date','ldsh!../templates/editor_advanced_date','ldsh!../templates/editor_advanced_variable','ldsh!../templates/editor_advanced_password','ldsh!../templates/editor_advanced_variable','ldsh!../templates/editor_advanced_variable','ldsh!../templates/editor_advanced_dropdown','ldsh!../templates/editor_advanced_date','ldsh!../templates/editor_advanced_date','ldsh!../templates/editor_advanced_password_amp','ldsh!../templates/field_editor'],function (require, exports, module) {
  'use strict';
  var Layout = require('base/layout'),
    CommonEditView = require('./base_element_editor'),
    CommonAdvancedEditView = require('./editor_advanced_common'),
    FieldAdvancedEditView = require('./editor_advanced_custom'),
    FieldEditorTitle = require('./field_editor_title'),
    util = require('lib/util');

  var FieldEditors = {
      'input:text': require('./editor_text'),
      'input:textarea': require('./editor_textarea'),
      'input:checkgroup': require('./editor_checkgroup'),
      'input:radiogroup': require('./editor_radiogroup'),
      'input:dropdown': require('./editor_dropdown'),
      'input:hidden': require('./editor_hidden'),
      'custom:terms': require('./editor_custom_terms'),
      'custom:privacy': require('./editor_custom_privacy'),
      'custom:telephone': require('./editor_custom_telephone'),
      'custom:email': require('./editor_custom_email'),
      'custom:date': require('./editor_custom_date'),
      'custom:date_amp': require('./editor_custom_date'),
      'custom:gender': require('./editor_custom_gender'),
      'custom:password': require('./editor_custom_password'),
      'custom:iban': require('./editor_custom_iban'),
      'custom:day': require('./editor_custom_range'),
      'custom:month': require('./editor_custom_month'),
      'custom:year': require('./editor_custom_range'),
      'custom:login:facebook': require('./editor_custom_fblogin'),
      'custom:login:linkedin': require('./editor_custom_linlogin'),
      'custom:captcha:google_recaptcha': require('./editor_custom_google_recaptcha'),
      'custom:separator': require('./editor_custom_separator'),
    },
    FieldAdvancedEditors = {
      'input:dropdown': require('ldsh!../templates/editor_advanced_dropdown'),
      'input:text': require('ldsh!../templates/editor_advanced_variable'),
      'input:hidden': require('ldsh!../templates/editor_advanced_variable'),
      'custom:date': require('ldsh!../templates/editor_advanced_date'),
      'custom:date_amp': require('ldsh!../templates/editor_advanced_date'),
      'custom:email': require('ldsh!../templates/editor_advanced_variable'),
      'custom:password': require('ldsh!../templates/editor_advanced_password'),
      'custom:telephone': require('ldsh!../templates/editor_advanced_variable'),
    },
    FieldAdvancedEditorsAMP = {
      'input:hidden': require('ldsh!../templates/editor_advanced_variable'),
      'input:dropdown': require('ldsh!../templates/editor_advanced_dropdown'),
      'custom:date': require('ldsh!../templates/editor_advanced_date'),
      'custom:date_amp': require('ldsh!../templates/editor_advanced_date'),
      'custom:password': require('ldsh!../templates/editor_advanced_password_amp'),
    };

  module.exports = Layout.extend({
    template: require('ldsh!../templates/field_editor'),
    regions: {
      title: '.js-title',
      common: '.js-common',
      field: '.js-field',
      commonAdvanced: '.js-common-advanced',
      fieldAdvanced: '.js-field-advanced',
    },
    initialize: function (options) {
      this.vent = options.vent;
      this.options = options.options;
      this.listenTo(this.vent, 'edit:field', this.showForm);
    },
    showForm: function (fieldModel) {
      this._closeAllEditViews();
      if (fieldModel) {
        this._createTitleEditView(fieldModel);
        this._createFieldCommonEditView(fieldModel);
        this._createFieldCustomEditView(fieldModel);
        this._createAdvancedFieldCustomEditView(fieldModel);
      }
    },
    _closeAllEditViews: function () {
      this.regions.title.close();
      this.regions.field.close();
      this.regions.common.close();
      this.regions.commonAdvanced.close();
      this.regions.fieldAdvanced.close();
    },
    _createTitleEditView: function (fieldModel) {
      this.regions.title.show(new FieldEditorTitle({ model: fieldModel }));
    },
    _createFieldCommonEditView: function (fieldModel) {
      if (!fieldModel.onlyFieldAttrs) {
        this.regions.common.show(
          new CommonEditView({
            model: fieldModel,
          })
        );
        this.regions.commonAdvanced.show(
          new CommonAdvancedEditView({
            vent: this.vent,
            model: fieldModel,
            options: this.options,
          })
        );
      }
    },
    _createFieldCustomEditView: function (fieldModel) {
      var ViewConstructor = FieldEditors[fieldModel.get('name')];
      if (fieldModel && ViewConstructor) {
        this.regions.field.show(
          new ViewConstructor({
            model: fieldModel,
            options: this.options,
          })
        );
      }
    },
    _createAdvancedFieldCustomEditView: function (fieldModel) {
      var advanceFieldsMap;
      if (util.isPlatformAMP(this)) {
        advanceFieldsMap = FieldAdvancedEditorsAMP;
      } else {
        advanceFieldsMap = FieldAdvancedEditors;
      }

      var template = advanceFieldsMap[fieldModel.get('name')];

      if (template) {
        this.regions.fieldAdvanced.show(
          new FieldAdvancedEditView({
            model: fieldModel,
            template: template,
            options: this.options,
          })
        );
      }
    },
  });
});

